import classes from 'components/App/AuthPublicPages/Login/login.module.scss';
import { Control, UseFormHandleSubmit, UseFormRegister } from 'react-hook-form';
import ActiveDirectory from 'components/App/AuthPublicPages/_common/LoginComponent/ActiveDirectory/activeDirectory';
import Layout from 'components/App/AuthPublicPages/_common/publicLayout/layout';
import React, { useMemo, useState } from 'react';
import { ILoginForm } from 'components/App/AuthPublicPages/Login/login';
import { FieldErrors } from 'react-hook-form/dist/types/errors';
import { CustomizedTabs, ITab } from 'components/common/CustomizedTabs/CustomizedTabs';
import { CredentialsForm } from 'components/App/AuthPublicPages/_common/LoginComponent/CredentialsForm/credentialsForm';

interface Props {
    title: string;
    handleSubmit: UseFormHandleSubmit<ILoginForm>;
    login: (data: ILoginForm) => void;
    errors: FieldErrors<ILoginForm>;
    register: UseFormRegister<ILoginForm>;
    control: Control<ILoginForm>;
    error?: string;
    isLoading: boolean;
    enableSSO: boolean;
}
type LoginActiveTab = 'foresightCredentials' | 'organisationalActiveDirectory';

export const LoginComponent = ({
    title,
    handleSubmit,
    login,
    errors,
    register,
    control,
    error,
    isLoading,
    enableSSO,
}: Props) => {
    const [activeTab, setActiveTab] = useState<LoginActiveTab>('organisationalActiveDirectory');
    const viewMode = useMemo(() => (enableSSO ? 'TABS_VIEW' : 'REGULAR_VIEW'), [enableSSO]);

    const tabs: ITab<LoginActiveTab>[] = [
        {
            value: 'organisationalActiveDirectory',
            label: 'Organisational Active Directory',
        },
        {
            value: 'foresightCredentials',
            label: 'Foresight Credentials',
        },
    ];

    return (
        <Layout>
            <div className={`${classes.loginFormWrapper} ${viewMode === 'TABS_VIEW' ? classes.tabsView : ''}`}>
                <div className={classes.loginFormTitleWrapper}>{title}</div>
                {viewMode === 'TABS_VIEW' ? (
                    <>
                        <CustomizedTabs<LoginActiveTab> tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />
                        {activeTab === 'foresightCredentials' ? (
                            <CredentialsForm
                                title={title}
                                handleSubmit={handleSubmit}
                                login={login}
                                errors={errors}
                                register={register}
                                control={control}
                                error={error}
                                isLoading={isLoading}
                            />
                        ) : (
                            <>
                                <ActiveDirectory />
                            </>
                        )}
                    </>
                ) : (
                    <CredentialsForm
                        title={title}
                        handleSubmit={handleSubmit}
                        login={login}
                        errors={errors}
                        register={register}
                        control={control}
                        error={error}
                        isLoading={isLoading}
                    />
                )}
            </div>
        </Layout>
    );
};
